import React from "react"
import tw from "twin.macro"
import Image from "next/image"

export interface EmbedAssetProps {
  src: string
  height: number
  width: number
  description: string
}

export default function EmbedAsset({ src, height, width, description }: EmbedAssetProps) {
  const placeholderImgUrl = src + "?w=25&h=25"

  const altText = description
    ? `${description} – The Richard Pousette-Dart Foundation`
    : `The Richard Pousette-Dart Foundation`

  return (
    <div tw="py-8 mx-auto flex flex-col max-w-[35em]">
      <Image src={src} height={height} width={width} alt={altText} placeholder="blur" blurDataURL={placeholderImgUrl} />

      {description && (
        <div tw="p-2 tablet:(p-4) flex justify-center">
          <p tw="!max-w-none text-rpd-gray-8 font-sans text-xs leading-[18px] tablet:(text-sm leading-[22px]) inline-block">
            {description}
          </p>
        </div>
      )}
    </div>
  )
}
